(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter-value-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('filter-value-finder')) {
    let listId = 0;
    customElements.define('filter-value-finder', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.input = this.querySelector('input[type="search"]');
        this.status = this.querySelector('[role="status"]');
        this.clear = this.querySelector('.filter-finder__clear');
        this.toggle = this.querySelector('.filter-finder__toggle');
        const list = this.querySelector('[data-filter-finder-values]');
        list.id ||= 'FilterValues-' + (++listId);
        this.toggle.setAttribute('aria-controls', list.id);
        this.narrow = window.matchMedia('(max-width: 989px)');
        this.narrow.addEventListener('change', () => this.filter(), options);
        this.rows = [...this.querySelectorAll('input[type="checkbox"]')].map(input => {
          const label = input.closest('label');
          const node = label.closest('li') || label;
          node.dataset.filterFinderRow = '';
          return { node, input, label: (label.querySelector('span')?.textContent || input.value).trim().toLocaleLowerCase() };
        });
        this.querySelector('.filter-finder__controls').hidden = false;
        this.input.addEventListener('input', () => this.filter(), options);
        this.addEventListener('change', () => this.filter(), options);
        this.input.addEventListener('keydown', event => {
          if (event.key === 'Enter') event.preventDefault();
          if (event.key === 'Escape' && this.input.value) { event.preventDefault(); event.stopPropagation(); this.input.value = ''; this.filter(); }
        }, options);
        this.clear.addEventListener('click', () => { this.input.value = ''; this.filter(); this.input.focus({preventScroll:true}); }, options);
        this.toggle.addEventListener('click', () => { this.expanded = !this.expanded; this.filter(); }, options);
        this.closest('form')?.addEventListener('reset', () => queueMicrotask(() => { if (this.isConnected) this.filter(); }), options);
        this.filter();
      }
      filter() {
        const query = this.input.value.trim().toLocaleLowerCase();
        const focusedRow = document.activeElement?.closest('[data-filter-finder-row]');
        let matches = 0;
        for (const [index, row] of this.rows.entries()) {
          const match = row.label.includes(query);
          if (match) matches += 1;
          const folded = !query && this.narrow.matches && !this.expanded && index >= 8;
          row.node.hidden = (!match || folded) && !row.input.checked;
        }
        this.toggle.hidden = Boolean(query) || !this.narrow.matches || !this.rows.slice(8).some(row => !row.input.checked);
        this.toggle.setAttribute('aria-expanded', String(Boolean(this.expanded)));
        this.toggle.textContent = this.expanded ? this.dataset.showLessLabel : this.dataset.showAllLabel.replace('__COUNT__', String(this.rows.length));
        if (focusedRow?.hidden && this.contains(focusedRow)) (this.toggle.hidden ? this.input : this.toggle).focus({ preventScroll: true });
        this.clear.hidden = !query;
        this.status.hidden = !query;
        this.status.textContent = query ? this.dataset.matchLabel.replace('__COUNT__', String(matches)) : '';
      }
      disconnectedCallback() {
        this.events?.abort();
        for (const row of this.rows || []) row.node.hidden = false;
        this.querySelector('.filter-finder__controls').hidden = true;
        if (this.toggle) this.toggle.hidden = true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-option-fieldset"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('balanced-size-options')) {
    customElements.define('balanced-size-options', class BalancedSizeOptions extends HTMLElement {
      connectedCallback() {
        this.frame = 0;
        this.layoutKey = '';
        this.observedText = null;
        this.schedule = () => {
          if (!this.isConnected || this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.updateLayout();
          });
        };
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this);
        this.mutationObserver = new MutationObserver(() => {
          this.layoutKey = '';
          this.schedule();
        });
        this.mutationObserver.observe(this, { childList: true, subtree: true, characterData: true });
        window.addEventListener('resize', this.schedule, { passive: true });
        document.fonts.addEventListener('loadingdone', this.schedule);
        document.fonts.ready.then(this.schedule);
        this.schedule();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        window.removeEventListener('resize', this.schedule);
        document.fonts.removeEventListener('loadingdone', this.schedule);
        cancelAnimationFrame(this.frame);
        this.frame = 0;
      }

      updateLayout() {
        if (!this.isConnected) return;
        const labels = Array.from(this.children).filter((node) => node.tagName === 'LABEL');
        const text = labels[0]?.firstElementChild || null;
        if (text !== this.observedText) {
          if (this.observedText) this.resizeObserver.unobserve(this.observedText);
          if (text) this.resizeObserver.observe(text);
          this.observedText = text;
        }
        const width = this.getBoundingClientRect().width;
        if (!labels.length || width <= 0) {
          this.layoutKey = '';
          this.style.removeProperty('--size-columns');
          return;
        }
        const gap = parseFloat(getComputedStyle(this).columnGap) || 0;
        const minimum = Math.max(44, parseFloat(getComputedStyle(labels[0]).minWidth) || 44);
        const key = [width, gap, minimum, labels.length].join(':');
        if (this.layoutKey === key) return;
        this.layoutKey = key;
        const capacity = Math.max(1, Math.floor((width + gap + .01) / (minimum + gap)));
        const rows = Math.ceil(labels.length / capacity);
        const columns = Math.ceil(labels.length / rows);
        const baseRowSize = Math.floor(labels.length / rows);
        const longerRows = labels.length % rows;
        const rowStarts = new Set();
        let index = 0;
        for (let row = 0; row < rows; row += 1) {
          rowStarts.add(index);
          index += baseRowSize + (row < longerRows ? 1 : 0);
        }
        this.style.setProperty('--size-columns', columns);
        labels.forEach((label, position) => {
          const start = rowStarts.has(position) ? '1' : '';
          if (label.style.gridColumnStart !== start) label.style.gridColumnStart = start;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-policy-access"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-policy-access')) {
    customElements.define('product-policy-access', class extends HTMLElement {
      disconnectedCallback() {
        this.querySelectorAll('dialog[open]').forEach((dialog) => window.Northyard?.closeDialog(dialog, false));
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const opener = event.target.closest('[data-policy-open]');
          const closer = event.target.closest('[data-policy-close]');
          const commerce = window.Northyard;
          if (opener && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
            const dialog = document.getElementById(opener.dataset.policyOpen);
            if (!dialog || !commerce?.openDialog) return;
            event.preventDefault();
            const content = dialog.querySelector('[data-policy-content]');
            if (content) {
              dialog.querySelector('[data-policy-body]').append(content.content.cloneNode(true));
              content.remove();
            }
            commerce.openDialog(dialog, opener);
          }
          if (closer) commerce?.closeDialog(closer.closest('dialog'));
          if (event.target.tagName === 'DIALOG') {
            const rect = event.target.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) commerce?.closeDialog(event.target);
          }
        });
        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener('cancel', (event) => {
            if (!window.Northyard?.closeDialog) return;
            event.preventDefault();
            window.Northyard.closeDialog(dialog);
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-review-assistance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-review-assistance')) {
    customElements.define('product-review-assistance', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.widget = this.closest('.product-reviews')?.querySelector('.product-reviews__widget');
        if (!this.widget) return;
        this.events = new AbortController();
        this.status = this.querySelector('[data-review-request-status]');
        this.message = this.querySelector('[data-review-request-message]');
        this.retry = this.querySelector('[data-review-retry]');
        this.reset();
        this.widget.addEventListener('click', (event) => {
          const control = event.target.closest('.jdgm-paginate__page[data-page]');
          if (!control || control.classList.contains('jdgm-curt')) return;
          this.begin(control);
        }, { capture: true, signal: this.events.signal });
        this.widget.addEventListener('change', () => this.reset(), { signal: this.events.signal });
        this.retry.addEventListener('click', () => {
          const target = [...this.widget.querySelectorAll('.jdgm-paginate__page')].find((node) => node.dataset.page === this.pending?.page && !node.classList.contains('jdgm-curt'));
          if (target) target.click();
          else this.reset();
        }, { signal: this.events.signal });
        this.observer = new MutationObserver(() => this.schedule());
        this.observer.observe(this.widget, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'data-review-id'] });
        this.enhance();
      }

      schedule() {
        if (this.frame || !this.isConnected) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.enhance(); });
      }

      fingerprint() {
        return [...this.widget.querySelectorAll('.jdgm-rev')].map((node) => node.dataset.reviewId || node.querySelector('.jdgm-rev__body')?.textContent || '').join('|');
      }

      begin(control) {
        clearTimeout(this.timer);
        this.pending = { page: control.dataset.page, before: this.fingerprint() };
        this.status.hidden = false;
        this.retry.hidden = true;
        this.message.textContent = this.dataset.loading;
        this.timer = setTimeout(() => {
          if (!this.pending) return;
          this.message.textContent = this.dataset.failed;
          this.retry.hidden = false;
        }, 12000);
      }

      reset() {
        clearTimeout(this.timer);
        this.pending = null;
        this.status.hidden = true;
        this.retry.hidden = true;
      }

      enhance() {
        this.observer?.disconnect();
        this.widget.querySelectorAll('.jdgm-rev').forEach((review) => {
          const pin = review.querySelector('.jdgm-rev__pinned');
          let label = review.querySelector('.ny-featured-review');
          if (!pin) { label?.remove(); return; }
          if (!label) { label = document.createElement('span'); label.className = 'ny-featured-review'; pin.after(label); }
          if (label.textContent !== this.dataset.featured) label.textContent = this.dataset.featured;
        });
        const sort = this.widget.querySelector('.jdgm-rev-widg__sort-wrapper');
        const select = sort?.querySelector('select');
        let note = this.widget.querySelector('.ny-featured-note');
        const hasPinned = Boolean(sort && this.widget.querySelector('.jdgm-rev__pinned'));
        if (sort && sort.classList.contains('ny-review-sort-help') !== hasPinned) sort.classList.toggle('ny-review-sort-help', hasPinned);
        this.noteId ||= `${this.closest('.shopify-section')?.id || 'product-reviews'}-sort-note`;
        if (hasPinned) {
          if (!note) { note = document.createElement('p'); note.className = 'ny-featured-note'; }
          note.id = this.noteId;
          if (note.parentElement !== sort) sort.append(note);
          if (note.textContent !== this.dataset.featuredNote) note.textContent = this.dataset.featuredNote;
        } else note?.remove();
        if (select) {
          const descriptions = (select.getAttribute('aria-describedby') || '').split(/\s+/).filter((id) => id && id !== this.noteId);
          if (hasPinned) descriptions.push(this.noteId);
          if (descriptions.length) select.setAttribute('aria-describedby', descriptions.join(' '));
          else select.removeAttribute('aria-describedby');
        }
        if (this.pending) {
          const active = this.widget.querySelector('.jdgm-paginate__page.jdgm-curt')?.dataset.page;
          const fingerprint = this.fingerprint();
          if (active === this.pending.page && fingerprint && fingerprint !== this.pending.before) {
            clearTimeout(this.timer);
            this.pending = null;
            this.message.textContent = this.dataset.loaded;
            this.retry.hidden = true;
          }
        }
        this.observer?.observe(this.widget, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'data-review-id'] });
      }

      disconnectedCallback() {
        this.events?.abort(); this.events = null;
        this.observer?.disconnect();
        clearTimeout(this.timer); cancelAnimationFrame(this.frame); this.frame = null;
        this.pending = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-review-form-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-review-form-status')) {
    customElements.define('product-review-form-status', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.section = this.closest('.product-reviews');
        this.status = this.querySelector('[data-review-form-status]');
        this.message = this.querySelector('[data-review-form-message]');
        this.actions = this.querySelector('[data-review-form-actions]');
        if (!this.section || !this.status || !this.message || !this.actions) return;
        this.events = new AbortController();
        this.section.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-testid="write-review-button"], .jdgm-write-rev-link');
          if (trigger && !trigger.disabled && trigger.getAttribute('aria-disabled') !== 'true') this.begin(trigger);
        }, { capture: true, signal: this.events.signal });
        this.querySelector('[data-review-form-retry]').addEventListener('click', () => {
          const trigger = this.trigger?.isConnected ? this.trigger : this.section.querySelector('[data-testid="write-review-button"], .jdgm-write-rev-link');
          if (trigger && !trigger.disabled) trigger.click();
        }, { signal: this.events.signal });
        this.querySelector('[data-review-form-reload]').addEventListener('click', () => window.location.reload(), { signal: this.events.signal });
        this.querySelector('[data-review-form-dismiss]').addEventListener('click', () => {
          const trigger = this.trigger;
          this.reset();
          if (trigger?.isConnected) trigger.focus({ preventScroll: true });
        }, { signal: this.events.signal });
        window.addEventListener('pagehide', () => this.reset(), { signal: this.events.signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.reset();
        }, { signal: this.events.signal });
      }

      formVisible() {
        return [...document.querySelectorAll('.jdgm-write-review-modal[role="dialog"], .product-reviews .jdgm-form')].some((form) => {
          const style = getComputedStyle(form);
          return form.getClientRects().length && style.display !== 'none' && style.visibility !== 'hidden' && form.getAttribute('aria-hidden') !== 'true';
        });
      }

      begin(trigger) {
        if (this.pending && !this.failed) return;
        this.reset();
        this.trigger = trigger;
        if (this.formVisible()) return;
        this.pending = true;
        this.observer = new MutationObserver(() => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            if (this.pending && this.formVisible()) this.reset();
          });
        });
        this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'class', 'style'] });
        this.showTimer = setTimeout(() => {
          if (this.formVisible()) { this.reset(); return; }
          this.message.textContent = this.dataset.opening;
          this.status.hidden = false;
        }, 700);
        this.failTimer = setTimeout(() => {
          if (this.formVisible()) { this.reset(); return; }
          this.failed = true;
          this.message.textContent = this.dataset.unavailable;
          this.actions.hidden = false;
          this.status.hidden = false;
        }, 8000);
      }

      reset() {
        clearTimeout(this.showTimer);
        clearTimeout(this.failTimer);
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.observer?.disconnect();
        this.pending = false;
        this.failed = false;
        if (this.status) this.status.hidden = true;
        if (this.actions) this.actions.hidden = true;
      }

      disconnectedCallback() {
        this.reset();
        this.events?.abort();
        this.events = null;
        this.trigger = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-size-guidance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-size-guidance')) {
    customElements.define('product-size-guidance', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.section = this.closest('[data-product-section]');
        this.dialog = this.querySelector('dialog');
        if (!this.section || !this.dialog) return;
        this.events = new AbortController();
        this.cells = [...this.dialog.querySelectorAll('[data-inch-value]')];
        this.rows = [...this.dialog.querySelectorAll('[data-chart-size]')];
        this.summary = this.querySelector('[data-size-summary]');
        this.referenceSummary = this.summary?.querySelector('[data-size-summary-reference]');
        this.unit = this.unit || 'in';
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 3, useGrouping: false });
        this.convertible = this.cells.length > 0 && this.cells.every((cell) => this.validMeasurement(cell.dataset.inchValue));
        this.querySelectorAll('[data-size-units], [data-summary-units]').forEach((units) => { units.hidden = !this.convertible; });
        this.setUnit(this.convertible ? this.unit : 'in');
        this.section.addEventListener('change', (event) => {
          if (event.target.matches('.product-option--size input[type="radio"]')) this.updateSelection();
        }, { signal: this.events.signal });
        this.section.addEventListener('click', (event) => {
          const opener = event.target.closest('[data-product-size-help]');
          if (!opener || !window.Northyard?.openDialog) return;
          event.preventDefault(); event.stopPropagation();
          this.updateSelection();
          window.Northyard.openDialog(this.dialog, opener);
          window.Northyard.emit?.('size_guide_open', {product_id: opener.dataset.productId, location: 'product_page'});
        }, { signal: this.events.signal });
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-size-guidance-close]')) window.Northyard?.closeDialog(this.dialog);
          const control = event.target.closest('[data-size-unit], [data-size-summary-unit]');
          if (control && this.convertible) {
            this.setUnit(control.dataset.sizeUnit || control.dataset.sizeSummaryUnit);
          }
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) window.Northyard?.closeDialog(this.dialog);
          }
        }, { signal: this.events.signal });
        this.dialog.addEventListener('cancel', (event) => { if (window.Northyard?.closeDialog) { event.preventDefault(); window.Northyard.closeDialog(this.dialog); } }, { signal: this.events.signal });
      }
      validMeasurement(value) {
        if (!/^\d+(?:\.\d+)?(?:\s*[-–]\s*\d+(?:\.\d+)?)?$/.test(value || '')) return false;
        const values = value.split(/\s*[-–]\s*/).map(Number);
        return values.every((number) => Number.isFinite(number) && number > 0) && (values.length === 1 || values[1] >= values[0]);
      }
      formatMeasurement(value) {
        return this.unit === 'in' ? value : value.split(/\s*[-–]\s*/).map((number) => this.formatter.format(Number(number) * 2.54)).join('–');
      }
      formatReference(value, kind) {
        const values = value.split(/\s*[-–]\s*/).map(Number);
        if (kind === 'height') {
          if (this.unit === 'cm') return `${this.formatMeasurement(value)} cm`;
          return values.map((value) => {
            const inches = Math.round(value * 1000) / 1000;
            const feet = Math.floor(inches / 12);
            return `${this.formatter.format(feet)}′${this.formatter.format(inches - feet * 12)}″`;
          }).join('–');
        }
        const metric = this.unit === 'cm';
        const unit = metric ? this.referenceSummary.dataset.kilogramsUnit : this.referenceSummary.dataset.poundsUnit;
        return `${values.map((value) => this.formatter.format(value * (metric ? 0.45359237 : 1))).join('–')} ${unit}`;
      }
      setUnit(unit) {
        this.unit = unit === 'cm' && this.convertible ? 'cm' : 'in';
        this.cells.forEach((cell) => { cell.textContent = this.formatMeasurement(cell.dataset.inchValue); });
        this.querySelectorAll('[data-size-unit], [data-size-summary-unit]').forEach((button) => {
          button.setAttribute('aria-pressed', String((button.dataset.sizeUnit || button.dataset.sizeSummaryUnit) === this.unit));
        });
        this.querySelectorAll('[data-size-unit-label]').forEach((label) => { label.textContent = this.unit; });
        this.updateSelection();
      }
      updateSelection() {
        const selected = this.section.querySelector('.product-option--size input:checked')?.value;
        const matchingRows = this.rows.filter((row) => row.dataset.chartSize === selected);
        this.rows.forEach((row) => row.setAttribute('aria-current', String(row.dataset.chartSize === selected)));
        if (!this.summary) return;
        const cells = matchingRows.length === 1 ? [...matchingRows[0].querySelectorAll('[data-inch-value]')] : [];
        const outputs = [...this.summary.querySelectorAll('[data-size-summary-value]')];
        const valid = cells.length === outputs.length && cells.every((cell) => this.validMeasurement(cell.dataset.inchValue));
        this.summary.hidden = !valid;
        const title = valid ? this.summary.dataset.summaryTitle.replace('__SIZE__', selected) : '';
        this.summary.querySelector('[data-size-summary-title]').textContent = title;
        this.summary.querySelector('[data-size-summary-announcement]').textContent = title;
        outputs.forEach((output) => {
          output.textContent = valid ? `${this.formatMeasurement(cells[Number(output.dataset.sizeSummaryValue)].dataset.inchValue)} ${this.unit}` : '';
        });
        if (!this.referenceSummary) return;
        const referenceRow = valid && this.dataset.referenceVerified === 'true' ? matchingRows[0] : null;
        let referenceCount = 0;
        this.referenceSummary.querySelectorAll('[data-size-reference-kind]').forEach((field) => {
          const kind = field.dataset.sizeReferenceKind;
          const value = referenceRow?.dataset[kind === 'height' ? 'heightInches' : 'weightPounds'];
          const show = this.validMeasurement(value);
          field.hidden = !show;
          field.querySelector('dd').textContent = show ? this.formatReference(value, kind) : '';
          if (show) referenceCount++;
        });
        this.referenceSummary.hidden = referenceCount === 0;
        this.summary.querySelector('[data-size-reference-note]').hidden = referenceCount === 0;
      }
      disconnectedCallback() {
        this.events?.abort(); this.events = null;
        if (this.dialog?.open) window.Northyard?.closeDialog(this.dialog, false);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
